import { e as environmentBlurSkyboxPatch } from '../_chunks/environment-blur-fragment-DdNuOPUC.js';
import { _registerEnvironmentSkyboxShaderPatch } from '../material/pbr/environment-skybox-shader-composer.js';
import { _registerSceneUboContributor, _invalidateSceneUboCaches } from './scene-ubo-extras.js';

const loadBlurSkyboxPatch = () => environmentBlurSkyboxPatch;
function writeEnvironmentBlurUbo(data, scene) {
  data[38] = scene._environmentBlur ?? 0;
  data[39] = scene._envTextures?.lodGenerationOffset ?? 0;
}
function setEnvironmentBlur(scene, blur) {
  scene._environmentBlur = blur;
  _registerEnvironmentSkyboxShaderPatch(scene, 1, loadBlurSkyboxPatch);
  _registerSceneUboContributor(scene, writeEnvironmentBlurUbo);
  _invalidateSceneUboCaches(scene);
}

export { setEnvironmentBlur };
//# sourceMappingURL=set-environment-blur.js.map
